import { useEffect, useState } from 'react';
import socket from '../services/socketService';

const useWatchPrices = () => {
	const [prices, setPrices] = useState({
		bcn_price: 0,
		bcn_price_usd: 0,
		bems_price: 0,
		bems_price_usd: 0,
		bsm_price: 0,
		bsm_price_usd: 0,
		currentPrice: 0,
		tim_price: 0,
		tim_price_usd: 0,
		trx_price: 0,
		date: new Date().toISOString(),
	});
	const handleUpdatePrice = (data) => setPrices((prevData) => ({ ...prevData, ...data }));

	useEffect(() => {
		socket.emitGetAllTokensPrices();
		socket.bemsSocket.on('allTokensPricePong', handleUpdatePrice);
		return () => socket.bemsSocket.off('allTokensPricePong', handleUpdatePrice);
	}, []);

	useEffect(() => {
		socket.bemsSocket.on('otherTokensPricePong', handleUpdatePrice);
		return () => socket.bemsSocket.off('otherTokensPricePong', handleUpdatePrice);
	}, []);

	useEffect(() => {
		socket.bemsSocket.on('initDataPong', handleUpdatePrice);
		return () => socket.bemsSocket.off('initDataPong', handleUpdatePrice);
	}, []);
	return [prices];
};

export default useWatchPrices;
